import { FormattedMessage, useIntl } from 'react-intl'
import AlertComponent from '../stories/molecules/alerts/index.jsx'
import {
  alertAlignVariantOptions,
  alertOrientationVariantOptions,
  alertVariantComponentOptions
} from '../stories/molecules/alerts/constants.js'
import { DescriptionContainer, DescriptionText } from './styled-components.js'
import { Unlock } from '../stories/atoms/icons/others/index.js'
import { buttonVariantOptions } from '../stories/atoms/button/constants.js'
import { useAuthStore } from '../../zustand/authentication/use-auth-store.jsx'
import { Link } from 'react-router-dom'
import { useGetFileMtlsCaQuery } from '../../react-query/certificate-modal/query/use-get-file-mtls-ca-query.jsx'
import { useGetFileMtlsClientQuery } from '../../react-query/certificate-modal/query/use-get-file-mtls-client-query.jsx'

const CheckCertificateModal = ({ isLoading, refetch }) => {
  const { logout } = useAuthStore()
  const { formatMessage } = useIntl()

  const { refetch: refetchGetCa, isLoading: isLoadingCa } =
    useGetFileMtlsCaQuery({
      enabled: false
    })

  const { refetch: refetchGetClient, isLoading: isLoadingClient } =
    useGetFileMtlsClientQuery({
      enabled: false
    })

  const downloadIsLoading = isLoadingCa || isLoadingClient

  const handleLogOut = () => {
    return logout()
  }

  const handleCheck = () => {
    return refetch()
  }

  const handleDownload = async () => {
    try {
      const caResult = await refetchGetCa()
      const clientResult = await refetchGetClient()

      const downloadFile = (data, filename) => {
        const blob = new Blob([data], { type: 'application/octet-stream' })

        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        window.URL.revokeObjectURL(url)
      }

      if (caResult?.data) {
        downloadFile(caResult.data, 'ca.p7b')
      }

      if (clientResult?.data) {
        downloadFile(clientResult.data, 'client.p12')
      }
    } catch (error) {
      console.error(error)
    }
  }

  const AlertDescription = () => {
    return (
      <DescriptionContainer>
        <Unlock
          style={{
            width: '96px',
            height: 'auto'
          }}
        />
        <div>
          <DescriptionText>
            <FormattedMessage id="certificate_modal_description" />
          </DescriptionText>
          <DescriptionText>
            <FormattedMessage id="certificate_modal_sub_description" />
          </DescriptionText>
        </div>
      </DescriptionContainer>
    )
  }

  return (
    <AlertComponent
      variant={alertVariantComponentOptions.CONFIRMATION}
      title={formatMessage({ id: 'certificate_modal_title' })}
      buttonOrientation={alertOrientationVariantOptions.STACKED}
      buttonAlignment={alertAlignVariantOptions.END}
      width="400px"
      activeOverlay={true}
      actionButtons={[
        {
          variant: buttonVariantOptions['GHOST-DESTRUCTIVE'],
          onClick: handleLogOut,
          children: formatMessage({ id: 'certificate_modal_logout' }),
          fullWidth: true
        },
        {
          variant: buttonVariantOptions['TERTIARY-HOLLOW'],
          children: formatMessage({ id: 'certificate_modal_install_guide' }),
          fullWidth: true,
          as: Link,
          to: 'https://support.docu-tools.com/en/articles/473086-installation-of-mtls-certificates-for-the-hybrid-solution-of-docu-tools-on-premise',
          target: '_blank'
        },
        {
          variant: buttonVariantOptions['SECONDARY-HOLLOW'],
          onClick: handleCheck,
          children: formatMessage({ id: 'certificate_modal_check' }),
          fullWidth: true,
          isLoading
        },
        {
          variant: buttonVariantOptions.PRIMARY,
          onClick: handleDownload,
          children: formatMessage({ id: 'certificate_modal_download' }),
          fullWidth: true,
          isLoading: downloadIsLoading
        }
      ]}
      style={{ zIndex: 9999 }}
    >
      <AlertDescription />
    </AlertComponent>
  )
}

export default CheckCertificateModal
